import React from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'

function DeleteAllButton({ notRead, deleteAll, size = 1 }) {
  const { t } = useTranslation()
  return (
    <Flex
      alignCenter={true}
      justifyCenter={true}
      style={{
        boxShadow: '0 -4px 6px -4px #e8e8e8',
        cursor: 'pointer',
        fontSize: `${16 * size}px`,
        fontWeight: 600,
        minHeight: `${50 * size}px`,
      }}
      onClick={deleteAll}
    >
      {`${t('BBO_930_clear_all_notification')} ${
        notRead && notRead !== 0 ? `(${notRead})` : ''
      }`}
    </Flex>
  )
}

export default DeleteAllButton
